import { Injectable } from '@angular/core';
import * as THBText from 'thai-baht-text';

@Injectable()
export class Number2textThService {

  constructor() {}

  currencyFormat_Baht(number) {
    if (!number) {
      return 'ศูนย์บาทถ้วน';
    }
    return THBText(number);
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/services/number2text-th.service.ts